export default __webpack_public_path__ + "static/media/dot_blue.c0444bb2.jpg";